import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from '../app-config';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { MixpanelService } from 'src/app/mixpanel.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolData } from 'src/app/models/schoolUser';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  is_job_only_user: any;
  redirectToPage: any;
  public schoolProps!: SchoolData;

  constructor(
    private http: HttpClient,
    private apiUrl: AppConfig,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private mixpanelService: MixpanelService,
    private _router: Router
  ) {
    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    });
  }
  private loggedIn: boolean = false;

  loginEmailVerify(loginDetails: any) {
    this.ngxService.start();
    return this.http
      .post<any>(this.apiUrl.commonApi.emailVerifyAPI, {
        otp: loginDetails.otp,
        user_id: loginDetails.user_id,
      })
      .pipe(
        map((userData) => {
          var user = userData;
          // console.log('Successfully logined data');
          this.loggedIn = true;
          document.cookie =
            'access_token=' +
            user.access_token +
            ';domain=.' +
            environment.cookiesDomain +
            ';path=/';
          document.cookie =
            'refresh_token=' +
            user.refresh_token +
            ';domain=.' +
            environment.cookiesDomain +
            ';path=/';
          return user;
        })
      );
  }
  login(loginDetails: any) {
    this.ngxService.start();
    return this.http
      .post<any>(this.apiUrl.commonApi.mfaOTPVerifyAPI, {
        otp: loginDetails.otp,
        user_id: loginDetails.user_id,
        remember_until: loginDetails.remember_until,
      })
      .pipe(
        map((userData) => {
          var user = userData;
          // console.log('Successfully logined data');
          this.loggedIn = true;
          document.cookie =
            'access_token=' +
            user.access_token +
            ';domain=.' +
            environment.cookiesDomain +
            ';path=/';
          document.cookie =
            'refresh_token=' +
            user.refresh_token +
            ';domain=.' +
            environment.cookiesDomain +
            ';path=/';
          return user;
        })
      );
  }
  loginMFA(userData: any) {
    var user = userData;
    console.log('Successfully logined data');
    this.loggedIn = true;
    document.cookie =
      'access_token=' +
      user.access_token +
      ';domain=.' +
      environment.cookiesDomain +
      ';path=/';
    document.cookie =
      'refresh_token=' +
      user.refresh_token +
      ';domain=.' +
      environment.cookiesDomain +
      ';path=/';
    return user;
  }
  loginOauth(loginDetails: any) {
    this.ngxService.start();
    return this.http
      .post<any>(this.apiUrl.createToken, {
        client_id: loginDetails.client_id,
        client_secret: loginDetails.client_secret,
        grant_type: loginDetails.grant_type,
        username: loginDetails.username,
        password: loginDetails.password,
        access_token: loginDetails.access_token,
        from_learnworld: loginDetails.from_learnworld,
      })
      .pipe(
        map((userData) => {
          var user = userData;
          // console.log('Successfully logined data');
          this.loggedIn = true;
          document.cookie =
            'access_token=' +
            user.access_token +
            ';domain=.' +
            environment.cookiesDomain +
            ';path=/';
          document.cookie =
            'refresh_token=' +
            user.refresh_token +
            ';domain=.' +
            environment.cookiesDomain +
            ';path=/';
          return user;
        })
      );
  }
  getToken(): string | null {
    return (
      document.cookie
        .match('(^|;)\\s*' + 'access_token' + '\\s*=\\s*([^;]+)')
        ?.pop() || ''
    );
  }

  getRefreshToken(): string | null {
    return (
      document.cookie
        .match('(^|;)\\s*' + 'refresh_token' + '\\s*=\\s*([^;]+)')
        ?.pop() || ''
    );
  }

  getUserData(): string | null {
    return localStorage.getItem('userData');
  }

  isLoggedIn() {
    return this.getToken() != '';
  }
  loggedOutCo() {
    this.commonService.logout('').subscribe({
      next: (res: any) => {
        console.log('Logout successful:', res);
      },
      error: (err: any) => {
        console.log('Error during logout API call:', err);
      }
    });

    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      this._router.ngOnDestroy();
      document.cookie =
        'refresh_token=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      document.cookie =
        'access_token=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      document.cookie =
        'userRole=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      document.cookie =
        'from=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      // this.ngxService.stop();

      // let currentUrl = "/login";
      // this._router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
      //   this._router.navigate([currentUrl]);
      // });
      // this._router.navigateByUrl('/login');

      window.open(environment.backToCoOrdinator, '_self');
    }, 2000);
    // return;

  }

  // loggedOutCo(get_user: any) {
  //   console.log('Logging out user');
  //   this.commonService.logout('').subscribe({
  //     next: (res: any) => {
  //       console.log('Logout successful:', res);
  //     },
  //     error: (err: any) => {
  //       console.log('Error during logout API call:', err);
  //     }
  //   });

  //   setTimeout(() => {
  //     localStorage.clear();
  //     sessionStorage.clear();
  //     this._router.ngOnDestroy();
  //     document.cookie =
  //       'refresh_token=; path=/; domain=.' +
  //       environment.cookiesDomain +
  //       '; expires=' +
  //       new Date(0).toUTCString();
  //     document.cookie =
  //       'access_token=; path=/; domain=.' +
  //       environment.cookiesDomain +
  //       '; expires=' +
  //       new Date(0).toUTCString();
  //     document.cookie =
  //       'userRole=; path=/; domain=.' +
  //       environment.cookiesDomain +
  //       '; expires=' +
  //       new Date(0).toUTCString();
  //     document.cookie =
  //       'from=; path=/; domain=.' +
  //       environment.cookiesDomain +
  //       '; expires=' +
  //       new Date(0).toUTCString();
  //     document.cookie =
  //       'bookings_on_off=; path=/; domain=.' +
  //       environment.cookiesDomain +
  //       '; expires=' +
  //       new Date(0).toUTCString();
  //     window.open(environment.backToCoOrdinator, '_self');
  //   }, 2000);
  //   // return;

  // }
  loggedOut() {
    // console.log('Logging out user');
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    const userType = this.schoolProps?.properties?.user_type;
    this.commonService.logout('').subscribe({
      next: (res: any) => {
        console.log('Logout successful:', res);
      },
      error: (err: any) => {
        console.log('Error during logout API call:', err);
      }
    });

    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      this._router.ngOnDestroy();
      document.cookie =
        'refresh_token=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      document.cookie =
        'access_token=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      document.cookie =
        'userRole=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      document.cookie =
        'from=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      document.cookie =
        'bookings_on_off=; path=/; domain=.' +
        environment.cookiesDomain +
        '; expires=' +
        new Date(0).toUTCString();
      // this.ngxService.stop();

      // let currentUrl = "/login";
      // this._router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
      //   this._router.navigate([currentUrl]);
      // });
      // this._router.navigateByUrl('/login');
      // console.log('Redirecting to login page');    
      // const hostname = window.location.hostname;
      // console.log('Current hostname:', hostname);
      if ((this.schoolProps?.properties?.is_qld_school && userType == 'School') || userType == 'Tracer') {
        window.open('/login-sso', '_self');
      } else {
        window.open('/login', '_self');
      }
    }, 2000);
    // return;

  }
  loggedOutOnUpdate() {
    // this.commonService.logout('').subscribe({
    //   next: (res: any) => {
    //     console.log('Logout successful:', res);
    //   },
    //   error: (err: any) => {
    //     console.log('Error during logout API call:', err);
    //   }
    // });
    localStorage.clear();
    sessionStorage.clear();
    this._router.ngOnDestroy();
    document.cookie =
      'refresh_token=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'access_token=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'userRole=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'from=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'bookings_on_off=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    this.ngxService.stop();

    // let currentUrl = "/login";
    // this._router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
    //   this._router.navigate([currentUrl]);
    // });
    // this._router.navigateByUrl('/login');

    window.open('/login', '_self');
  }
  loggedOutCookieClear() {
    // this.commonService.logout('').subscribe({
    //   next: (res: any) => {
    //     console.log('Logout successful:', res);
    //   },
    //   error: (err: any) => {
    //     console.log('Error during logout API call:', err);
    //   }
    // });
    localStorage.clear();
    sessionStorage.clear();
    this._router.ngOnDestroy();
    document.cookie =
      'refresh_token=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'access_token=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'userRole=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'from=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'bookings_on_off=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
  }

  deleteCookie(cookiename: any) {
    var d = new Date();
    d.setDate(d.getDate() - 1);
    var expires = ';expires=' + d;
    var name = cookiename;
    //alert(name);
    var value = '';
    document.cookie = name + '=' + value + expires + '; path=/acc/html';
  }

  public getCredentials = (user_id: any): Observable<any> => {
    return this.http.get<any>(this.apiUrl.getUserCredentail + user_id);
  };
}